import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import '../Components/WorkbookStyle.css';
import { Container, Col, Row, Card, Accordion } from 'react-bootstrap'
import axios from 'axios';
import moment from 'moment';

import firebase from 'lib/firebase';
import api from 'lib/api';
import global from 'lib/global';

import * as UserActions from 'store/modules/UserModule';


class MypageClassItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 마이페이지
            userInfo: {},

            class_data: [],
            page: 0,
            page_all: [],
        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });

        this.dataLoad();
    }

    dataLoad = () => {
        const self = this;
        api.post('/workbook/workbook/list', {})
            .then(function (result) {
                if (result.data.result) {
                    let data = result.data.data;
                    let countPage = data.length;

                    self.setState({
                        class_data: data,
                        page_all: countPage,
                    });
                }
            })
            .catch(err => {
                console.log("tab err", err)
            })
    }

    onClickClassPage = (e) => {
        // console.log("click page:", e.target.innerText)
        this.setState({ page: e.target.innerText - 1 })
    }

    onClickClassPagePre = () => {
        // console.log("click page pre")
        if (this.state.page > 0) {
            this.setState({ page: this.state.page - 1 })
        }
        return;
    }

    onClickClassPageNext = () => {
        // console.log("click page next")
        let maxPage = Math.round(this.state.page_all / 3);
        if (this.state.page < maxPage) {
            this.setState({ page: this.state.page + 1 })
        }
        return;
    }


    render() {
        let LayoutClass;

        if (this.props.userInfo && this.props.userInfo.idx) {
            let listClass = [];
            this.state.class_data.forEach(function (data, index) {
                let code_url = "https://workbook.boomco.io/sub/" + data.code;

                let getDate = moment(data.send_date).format("YYYY-MM-DD");
                let item = [(
                    <Row className="classContainer">
                        <Col xs={2} md={2} className="my-auto classDate" style={{ textAlign: 'center', padding: 0 }}>
                            <p>{data.round}</p>
                            <p>{getDate}</p>
                        </Col>
                        <Col xs={10} md={6} className="my-auto classTitle">
                            <a href={code_url} target={"_blank"}>{data.title}</a>
                        </Col>
                        <Col xs={6} md={2} className="my-auto classIcon">
                            <img
                                src={data.get_type > 0 ? "/write/my_icon_submitted_on.png" : "/write/my_icon_submitted_off.png"}
                                alt="icon_submitted" className="progressIcon" />
                        </Col>
                        <Col xs={6} md={2} className="my-auto classIcon">
                            <img
                                src={data.edit_type > 0 ? "/write/my_icon_feedback_on.png" : "/write/my_icon_feedback_off.png"}
                                alt="icon_feedback" className="progressIcon" />
                        </Col>
                    </Row>
                )];
                listClass.push(item)
            })
            let sliceListClass = listClass.slice(this.state.page * 3, this.state.page * 3 + 3)

            // class list pages
            let stylePageOn = { marginLeft: '1%', marginRight: '1%', color: '#ce3b33', borderBottomWidth: 1, borderBottomColor: '#ce3b33', borderBottomStyle: 'solid', paddingBottom: 3 };
            let stylePageOff = { marginLeft: '1%', marginRight: '1%', color: '#999', borderBottomWidth: 0 };
            let listPage = [];
            var i = 0;
            for (i = 0; i < this.state.page_all / 3; i++) {
                let labelPage = i + 1;
                let item = (
                    <span onClick={(e) => this.onClickClassPage(e)} style={this.state.page == i ? stylePageOn : stylePageOff}>{labelPage}</span>
                );
                listPage.push(item)
            }

            LayoutClass = (
                <Container className="mypage_class">
                    {sliceListClass}
                    <Container style={{ color: '#999', textAlign: 'center', marginTop: '5%', cursor: 'pointer' }}>
                        <span onClick={this.onClickClassPagePre}>Pre</span>
                        <span style={{ marginLeft: '4%', marginRight: '4%' }}>{listPage}</span>
                        <span onClick={this.onClickClassPageNext}>Next</span>
                    </Container>
                </Container>
            )
        }

        return (
            <div id="write_ad">
                {LayoutClass}
            </div>
        )
    }
}




let mapStateToProps = (state) => ({
    userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MypageClassItem);